import { render } from "./EmailEditTemplate.vue?vue&type=template&id=beab0b60"
import script from "./EmailEditTemplate.vue?vue&type=script&lang=js"
export * from "./EmailEditTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__